import React from 'react';

function Component() {
  return (
    <div>
      <h3>
        404
      </h3>
    </div>
  );
}

export default Component;
